import { doodBlockConfig } from './dood-block-config';
import type { IBlockDescriptor } from './descriptor';

/** Minimal serializable product stub used only for `products.length` on order cards. */
export type OrdersPagePreviewProduct = {
  id: string;
};

/** Serializable order card payload for CB2 preview scenarios. */
export type OrdersPagePreviewOrder = {
  id: string;
  number: string;
  status: string;
  final_price: number;
  ready_at: string | null;
  shop: {
    id: string;
    name: string;
  } | null;
  products: readonly OrdersPagePreviewProduct[];
};

/**
 * Serializable preview VM for `OrdersPageBlockComponent`.
 * Kept in content-builder so dashboard + webapp share the same transport shape.
 */
export type OrdersPageBlockScenarioContent = {
  activeOrders: readonly OrdersPagePreviewOrder[];
  historicalOrders: readonly OrdersPagePreviewOrder[];
  isActiveOrdersLoading: boolean;
  isHistoricalOrdersLoading: boolean;
};

const {
  ordersPageBlockDescriptor: _generatedOrdersPageBlockDescriptor,
  ordersPageBlockBlocDefinition,
  ordersPageBlockDashboardLayout,
  ordersPageBlockConfig,
  ordersPageBlockResolveConfig,
  ordersPageBlockProperties,
  ordersPageBlockDefinitionSetupScenarios,
} = doodBlockConfig(
  {
    id: 'orders-block',
    name: 'Orders',
    componentType: 'OrdersPageBlockComponent',
    category: 'content',
    hideFromPicker: true,
    description: 'List of current and past orders for the authenticated user.',
    keywords: ['orders', 'history'],
    allowed_in: ['OrdersPage'],
    sharedFields: {},
  },
  () => ({}),
  () => 'displayAll',
);

export function ordersPageBlockDescriptor(): IBlockDescriptor {
  return _generatedOrdersPageBlockDescriptor;
}

export {
  ordersPageBlockBlocDefinition,
  ordersPageBlockDashboardLayout,
  ordersPageBlockConfig,
  ordersPageBlockResolveConfig,
  ordersPageBlockProperties,
  ordersPageBlockDefinitionSetupScenarios,
};

export type OrdersPageBlockConfig = typeof ordersPageBlockConfig;
